import axios, { AxiosRequestConfig } from 'axios';
import interceptor from './interceptor';
import { Auth } from 'aws-amplify';

const getUri = (uri: string, params?: Array<{ param: string, value: string }>): string => {
    let newUri = uri;
    // Select the queryParams that matches the incoming set from params
    if (params) for (const param of params) newUri = newUri.replace(param.param, param.value);
    return process.env.REACT_APP_API_URL + newUri;
};

const getData = async (uri: string) => {
    const currentSession: any = await Auth.currentSession();
    const options: AxiosRequestConfig = {
        method: 'GET',
        url: uri,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            'Authorization': currentSession && currentSession.idToken && currentSession.idToken.jwtToken ? `${currentSession.idToken.jwtToken}` : ''
        }
    };
    return await axios(options);
};
const postData = async (uri: string, bodyString?: any, header?: any) => {
    const currentSession: any = await Auth.currentSession();
    if (header) {
        const { Authorization } = header;
        if (Authorization) await interceptor(Authorization);
    }
    const headers = {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'Authorization': currentSession && currentSession.idToken && currentSession.idToken.jwtToken ? `${currentSession.idToken.jwtToken}` : ''
    };
    return await axios.post(uri, bodyString, { headers });
};
export default { getUri, getData, postData };                                                                                                                                                               